import { render, staticRenderFns } from "./VDcReview.vue?vue&type=template&id=289ce312&"
import script from "./VDcReview.vue?vue&type=script&lang=js&"
export * from "./VDcReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports